var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGearBold = function SvgGearBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.963 8.138q.474.437.9.9l3.412.487c.556.966.985 2 1.275 3.075l-2.075 2.763s.038.85 0 1.274L28.55 19.4a12.8 12.8 0 0 1-1.275 3.075l-3.412.487s-.588.613-.9.9l-.488 3.413A13 13 0 0 1 19.4 28.55l-2.762-2.075a7 7 0 0 1-1.275 0L12.6 28.55a12.8 12.8 0 0 1-3.075-1.275l-.487-3.412a23 23 0 0 1-.9-.9l-3.413-.488c-.556-.966-.984-2-1.275-3.075l2.075-2.762s-.037-.85 0-1.276L3.45 12.6c.29-1.076.718-2.11 1.275-3.075l3.413-.487q.437-.463.9-.9l.487-3.413c.966-.556 2-.985 3.075-1.275l2.763 2.075q.637-.057 1.275 0L19.4 3.45c1.076.29 2.11.718 3.075 1.275z"
  })));
};
export default SvgGearBold;